// Primary Components
import ShiftInformation from '../../components/ShiftInformation/ShiftInformation';
import AddShiftForm from '../../components/AddShiftForm/AddShiftForm';

/**
 * Drawer Types Enum for Admin Shift View
 * Hierarchy:
 * - Base Drawers (no parent)
 *   - Shift Information
 *   - Add Shift Form
 */
export const DRAWER_TYPES = {
  // Shift Information
  SHIFT_INFORMATION: 'shiftInformation',

  // Add Shift Form
  ADD_SHIFT: 'addShift',
};

export const DRAWER_CONFIG = {
  // Shift Information Drawer
  [DRAWER_TYPES.SHIFT_INFORMATION]: {
    component: ShiftInformation,
    parent: null,
    props: ({ drawerData, handleCloseDrawer, handleBackNavigation }) => ({
      shift: drawerData?.shift,
      isAssigned: drawerData?.isAssigned,
      handleCloseDrawer,
      handleBackNavigation,
      shouldNavigateBackOnDelete: false, // Close drawer entirely when deleting
      isNewShift: false,
    }),
  },

  // Add Shift Form Drawer
  [DRAWER_TYPES.ADD_SHIFT]: {
    component: AddShiftForm,
    parent: null,
    props: ({ drawerData, handleCloseDrawer }) => ({
      onClose: handleCloseDrawer,
      selectedDate: drawerData?.selectedDate,
      dateFromShiftButton: drawerData?.dateFromShiftButton,
      preSelectedRole: drawerData?.preSelectedRole,
      handleSelectedDate: (date) => {
        // This can be used to update the parent component if needed
      },
    }),
  },
};